import { createBrowserRouter } from 'react-router-dom';

import { getAppSettings } from '../../config/appSettings';

const appSettings = getAppSettings();

// `Root` (and everything it pulls in - the whole app, redux store, ducks, etc.) is loaded lazily
// rather than imported eagerly here. Sagas import `router` from this module purely for
// `router.navigate`, and several ducks are themselves transitively imported by `Root`
// (via RootRouter's feature containers); an eager `import Root from './Root'` here would create
// a circular import back into those same ducks.
export const router = createBrowserRouter(
  [{ path: '*', lazy: () => import('./Root').then(module => ({ Component: module.default })) }],
  {
    basename: appSettings.client.basename,
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);
